import { useEffect, useRef } from "react";

function Recaptcha({ sitekey, theme = "light", type = "image" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    window.grecaptcha.render(containerRef.current, { sitekey, theme, type });
  }, [sitekey, theme, type]);

  return <div className="g-recaptcha" ref={containerRef} />;
}

export default Recaptcha;
